import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    display: 'flex',
    columnGap: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
}));

export default useStyles;
